<template>
  <div v-if="options">
    <div class="d-flex align-items-center">
      <b-avatar rounded size="42" variant="light-primary" class="mr-1">
        <feather-icon :icon="options.icon" size="20" />
      </b-avatar>
      <div>
        <h4 class="mb-0">
          {{ options.title }}
        </h4>
        <span>{{ options.subtitle }}</span>
      </div>
    </div>
    <!-- collapse -->
    <app-collapse id="faq-payment-qna" accordion type="margin" class="mt-2">
      <app-collapse-item v-for="(data, index) in options.qa" :key="index" :title="data.question"
        v-if="(!data.forProfessionals && !data.forParents) || $can('create', 'A.QA')">
        {{ data.ans }}
        <!-- - {{ data.forParents }} - {{ data.forProfessionals }} -->
        <b-button @click="showOptions(data)" :to="{
            name: 'diko-faq-edit',
            params: { id: data.id },
            query: { ...data, category: options.title },
          }" v-if="$can('create', 'A.QA')" style="padding: 3px; float: right" variant="primary"><feather-icon
            icon="EditIcon"></feather-icon></b-button>
        <b-button @click="deleteQA(data.id)" v-if="$can('delete', 'A.QA')"
          style="padding: 3px; margin-right: 5px; float: right" variant="primary"><feather-icon
            icon="XSquareIcon"></feather-icon></b-button> </app-collapse-item><!--  -->
    </app-collapse>
    <!--/ collapse -->
  </div>
</template>

<script>
import { BAvatar, BButton } from "bootstrap-vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import axios from "@axios";

export default {
  components: {
    BAvatar,
    AppCollapseItem,
    AppCollapse,
    BButton,
  },
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    showOptions(args) {
      console.log(args);
    },
    deleteQA(id) {
      axios
        .delete(`/qa/qa/${id}`)
        .then((response) => {
          console.log(response);
          this.$emit("faqDeleted");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
